export const sectionObject = ({
  section, sectionIndex, field, fieldIndex,
}) => ({
  id: section.id,
  fieldId: field.id,
  type: section.type,
  lockType: section.lockType,
  formatBlacklist: section.formatBlacklist,

  sectionIndex,
  fieldIndex,

  previousSectionId: null,
  nextSectionId: null,
});

export const setPreviousSection = (section, previousSection) => {
  if (!previousSection) {
    return;
  }

  // eslint-disable-next-line no-param-reassign
  section.previousSectionId = previousSection.id;
  // eslint-disable-next-line no-param-reassign
  previousSection.nextSectionId = section.id;
};
